import { createContext, use } from "react"

type CustomTraySolutionFormContextType = {
  storeId?: number
}

export const CustomTraySolutionFormContext = createContext<CustomTraySolutionFormContextType>({})
export const useSolutionFormContext = () => use(CustomTraySolutionFormContext)
